import { TFunction } from 'i18next'
import * as Yup from 'yup'

export const createEmailValidationSchema = (t: TFunction) =>
  Yup.object({
    emailAddress: Yup.string()
      .default('')
      .email(t('admin.checkEmailsPage.emailIsInvalidErrorMessage'))
      .required(t('admin.checkEmailsPage.emailIsRequiredErrorMessage')),
  }).defined()
